<template>
  <label class="uk-margin" v-bind:for="name">
    <div class="uk-form-label uk-display-block" v-bind:for="name">
      {{ label }}{{ required ? '*' : '' }}
    </div>

    <div class="kmc-field-help-text" v-if="helpText">
      {{ helpText }}
    </div>

    <label class="kmc-input kmc-input-text">
      <span class="prefix">
      </span>
      <input ref="input" :name="name" :id="name" :type="'text'" :value="inputValue" :invalid="!meta.valid"
        @input="handleChange" @blur="onBlur" :minlength="minLength" :maxlength="maxLength" :list="list"
        :autocomplete="'none'" />
      <div class="border"></div>
      <span class="suffix"></span>
    </label>

    <div class="kmc-field-error-text">
      {{ errorMessage }}
    </div>

  </label>

</template>

<script>

import { onMounted, ref, watch } from 'vue'
import { useField } from "vee-validate";

export default {
  name: "KmcInputText",
  components: {},
  props: {
    helpText: {
      type: String,
    },
    required: {},
    minLength: {},
    maxLength: {},
    list: {},
    value: {
      type: String
    },
    name: {
      type: String,
      default: "field name"
    },
    label: {
      type: String,
      default: "missing label"
    },
  },
  setup: function (props, context) {

    const input = ref(null)

    const {
      value: inputValue,
      errorMessage,
      handleBlur,
      handleChange,
      meta,
    } = useField(props.name, undefined, {
      initialValue: props.value,
    });

    watch(errorMessage, (current, previous) => {
      input.value.setCustomValidity(current || '');
    })

    onMounted(() => {
      input.value.setCustomValidity(errorMessage.value || '');
    })

    const onBlur = (e) => {
      const trimmed = e.target.value.trim()
      e.target.value = trimmed;
      handleChange(trimmed)
      handleBlur(e);
    }

    return {
      input,
      handleChange,
      onBlur,
      errorMessage,
      inputValue,
      meta
    };
  }
}

</script>
